const zhTW = {
    '青瓷游戏官方充值中心': 'Snell Game官方儲值中心',
    '官方充值': '官方儲值',
    '我的订单': '我的訂單',
    '联系客服': '聯繫客服',
    '您好，请登录': '您好,請登錄',
    '注销': '註銷',
    '最强蜗牛': 'Super Snail',
    '角色名称.游戏区组': '角色名稱：遊戲伺服器',
    '代钞': 'Voucher',
    '所选商品': '所選商品',
    '含': '含',
    '赠': '贈',
    '等待支付结果完成中': '等待付款結果完成中',
    '请稍后': '請稍候',
    '代钞具体到账情况请到': '代鈔相關帳務情況請到',
    '游戏“背包”中进行查看': '遊戲"背包"中進行查看',
    '支付查询中': '付款查詢中',
    '合计': '合計',
    '充值说明': '儲值說明',
    '立即支付': '立即付款',
    '青瓷游戏': 'Snell Game',
    '官方充值中心': '官方儲值中心',
    '角色名称': '角色名稱',
    '游戏区组': '遊戲伺服器',
    '充值账号': '儲值帳號',
    '选择游戏区组': '選擇遊戲伺服器',
    '苹果': '蘋果',
    '安卓': '安卓',
    '请选择区组': '請選擇伺服器',
    '请选择角色': '請選擇角色',
    '取消': '取消',
    '确定': '確定',
    '温馨提示': '溫馨提醒',
    '游戏维护期间，暂时无法为您充值，给您造成的不便敬请谅解': '遊戲維護期間,暫時無法為您儲值,造成不便敬請見諒。',
    '好的': '好的',
    '请选择商品类目': '請選擇商品品項',
    '请选择区组信息': '請選擇伺服器訊息',
    '登录': '登錄',
    '请先同意下方《青瓷游戏隐私政策》、《青瓷游戏用户服务协议》': '請先同意下方《Snell Game隱私政策》、《Snell Game用戶服務協議》',
    '邮箱信息填写错误': '信箱訊息填寫錯誤',
    '登录成功': '登錄成功',
    '共': '共',
    '条': '條',
    '选择需要充值的游戏': '選擇需要儲值的遊戲',
    '您好，': '您好，',
    '暂无信息': '暫無訊息',
    '请登录': '請登錄',
    '购买的代劵将反映在以下账号内，请确认内容无误': '購買的代金券將顯示在以下帳號內，請確認內容無誤',
    '支付成功': '付款成功',
    '代钞具体到账情况请到游戏“背包”中进行查看': '代鈔相關帳務情況請到遊戲“背包＂中進行查看',
    '支付失败': '付款失敗',
    '请稍后再试': '請稍候再試',
    '查看订单': '查看訂單',
    '网络超时,请刷新页面或稍后重试': '連線超時，請重整頁面或稍候再試',
    '订单号': '訂單號碼',
    '下单时间': '訂單時間',
    '开始日期': '開始日期',
    '至': 'to',
    '结束日期': '結束日期',
    '没有更多了': '沒有更多了',
    '全部游戏': '全部遊戲',
    '恭喜您复制成功，赶快去粘贴吧': '恭喜您複製成功，趕快去貼上吧',
    '操作失败，请重试！': '操作失敗，請重試！',
    '遇到问题？': '遇到問題？',
    '邮箱账号登录': '信箱帳號登錄',
    '请输入邮箱': '請輸入信箱',
    '请输入密码': '請輸入密碼',
    '查看如何拥有邮箱账号': '查看如何取得信箱帳號',
    '年龄认证': '年齢確認',
    '您的年龄决定了您每月可以购买的可计费项目的数量。': '您的年齡決定了您每月可以購買付款項目的數量',
    '请输入正确的出生日期。': '請輸入正確的出生日期',
    '设定的出生日期以后不能更改。': '出生日期設定後無法更改',
    '16岁以下': '18歲及以上',
    '16岁以上18岁未满': '16歲以上18歲未滿',
    '18岁及以上': '18歳以上',
    '1个月': '1個月',
    '无限制': '無限制',
    '5000元以下': '5000台幣以下',
    '20000元以下': '20000台幣以下',
    '年': '年',
    '月': '月',
    '日': '日',
    '元': '元',
    '阅读并同意': '閱讀並同意',
    '《青瓷游戏隐私政策 》': '《Snell Game隱私政策》',
    '《青瓷游戏用户服务协议》': '《Snell Game用戶服務協議》',
    '在进行支付时，由于支付渠道相关规则，可能出现超额提醒、限额提醒、风险提醒等，可切换支付方式后再次尝试': '在進行付款時,由於付款管道相關規則,如出現超額提醒、限額提醒、風險提醒等時,可切換付款方式後再次使用。',
  }
  
  export default zhTW